import { FC, useEffect } from "react";

import { Select, MenuItem, InputLabel, FormHelperText, FormControl } from "@mui/material"
import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { useComerOrigin } from "./hooks/useComerOrigin";


interface ComerOriginSelectField {
  label?: JSX.Element;
  onNoAvailableComersUpdate: () => void; 
  gas?: boolean;
}


const ComerOriginSelectField: FC<ComerOriginSelectField> = ({ 
  label, 
  gas = false, 
  onNoAvailableComersUpdate, 
}) => {
  const { t } = useTranslation();
  const comersData = useComerOrigin(gas);

  const { 
    control
  } = useFormContext();

  useEffect(() => {
    if ((comersData.isSuccess && comersData.data.length == 0) 
      || comersData.isError) {
      onNoAvailableComersUpdate();
    }
  }, [comersData?.data]);

  return (
    <div>
      <Controller
        name={"comerOrigin"}
        control={control}
        render={({field, fieldState}) => (<FormControl
                  style={{ width: "100%" }}
                >
          <InputLabel id="comerOriginLabel">
            {(label || t('common:text.contractation_comer_origin')) + "*"}
          </InputLabel>
          <Select
            {...field}
            fullWidth={true}
            variant="standard"
            labelId="comerOriginLabel" // Necessary for testing: https://v6.mui.com/material-ui/react-select/#accessibility
            error={!!(fieldState.error)}
          >
            {comersData.isSuccess &&
              comersData.data.map((c) => {
                return <MenuItem key={c.id} value={c.id.toString()}>{c.name}</MenuItem>;
              })
            }
          </Select>
          {fieldState.error?.message &&
            <FormHelperText error={true}>
              {t(fieldState.error.message)}
            </FormHelperText>
          }
        </FormControl>)}
      />

      
    </div>
  );
};

export default ComerOriginSelectField;
